import { Controller } from "@hotwired/stimulus"

// 画像URLとして許可するスキーム。javascript: や data: を src に入れられないようにする。
const ALLOWED_IMAGE_PROTOCOLS = ["http:", "https:"];

export default class extends Controller {
  connect() {
    const links = Array.from(this.element.querySelectorAll("a")).filter(link => {
      return link.parentElement?.classList.contains('page_link') || link.querySelector('.page_link');
    });

    links.forEach(link => {
      const url = link.href || link.querySelector("a")?.href;
      if (!url) return;

      fetch(`/note/meta_tags?url=${encodeURIComponent(url)}`)
        .then(response => response.json())
        .then(({ title, image }) => {
          link.replaceWith(this.buildRichLink(url, title, image));
        })
        .catch(error => {
          console.error("OGP fetch failed:", error);
        });
    });
  }

  // title / image はリンク先の外部サイトが返す値であり、記事の編集者にも制御できない。
  // innerHTML に流すとDOM XSSになるため、テキストノードと属性として組み立てる。
  buildRichLink(url, title, image) {
    const container = document.createElement("a");
    container.href = url;
    container.target = "_blank";
    container.rel = "noopener noreferrer";
    container.classList.add("rich-link");

    const imageWrapper = document.createElement("div");
    imageWrapper.className = "rich-link__image";

    const imageUrl = this.safeImageUrl(image);
    if (imageUrl) {
      const img = document.createElement("img");
      img.src = imageUrl;
      img.alt = "";
      imageWrapper.appendChild(img);
    }

    const content = document.createElement("div");
    content.className = "rich-link__content";

    const titleElement = document.createElement("p");
    titleElement.className = "rich-link__title";
    titleElement.textContent = title || "";

    content.appendChild(titleElement);
    container.append(imageWrapper, content);

    return container;
  }

  safeImageUrl(image) {
    if (!image) return null;

    try {
      const parsed = new URL(image, window.location.href);
      return ALLOWED_IMAGE_PROTOCOLS.includes(parsed.protocol) ? parsed.href : null;
    } catch {
      return null;
    }
  }
}
